import { useEffect } from "react";

/**
 * @param {{ loadData: () => void; reloadIntervalInSeconds: number; skipFirstLoad?: boolean;}} param0
 */
export const useDataReload = ({
  loadData,
  reloadIntervalInSeconds,
  skipFirstLoad = false,
}) => {
  useEffect(() => {
    if (!skipFirstLoad) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (reloadIntervalInSeconds) {
        loadData();
      }
    }, reloadIntervalInSeconds * 1000);

    return () => clearTimeout(timeout);
  });
};
